import { render, staticRenderFns } from "./SPRPager.vue?vue&type=template&id=0833302a"
import script from "./SPRPager.vue?vue&type=script&lang=ts"
export * from "./SPRPager.vue?vue&type=script&lang=ts"
import style0 from "./SPRPager.vue?vue&type=style&index=0&id=0833302a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports